import React, { Component, PropTypes } from 'react'
import { translate } from 'react-i18next'
import { fromJS } from 'immutable'
import styled from 'styled-components'
import Grid from 'grid-styled'
import R from 'ramda'
import {
  addOrRemoveObjectFromList,
  isElementInArray,
  numberWithCommas
} from '../../Utils'
import { findUsers, acceptUsers, rejectUsers } from '../../sources/AdminSource'
import AdminNavbar from '../../components/AdminNavbar'
import ThemeContainer from '../../components/ThemeContainer'
import CardContainer from '../../components/CardContainer'
import Avatar from '../../components/Avatar'
import { Metrics, Fonts } from '../../Themes'
import Checkbox from '../../components/Checkbox'
import Tag from '../../components/Tag'
import Loader from '../../components/Loader'

const PageContainer = styled.section`
  height: 100vh;
  overflow: hidden;
  position: relative;
`

const Preference = styled.div`${Fonts.style.Text};`

const CustomCardContainer = styled(CardContainer)`
  margin-top: ${Metrics.margins.base};
`

const Title = styled.div`${Fonts.style.Label};`

const CustomGrid = styled(Grid)`
  margin-top: ${props => (props.noPadTop ? 0 : Metrics.margins.base)};
  padding-left: ${props => (props.noPadLeft ? 0 : Metrics.margins.medium)};
  padding-right: ${props => (props.noPadRight ? 0 : Metrics.margins.medium)};
  display: table-cell;
  vertical-align: middle;
  ${props => props.width && `width: ${props.width}px`};
`
const CustomGridContainer = styled(Grid)`
  margin-top: ${props => (props.noPadTop ? 0 : Metrics.margins.base)};
  padding-left: ${props => (props.noPadLeft ? 0 : Metrics.margins.medium)};
  padding-right: ${props => (props.noPadRight ? 0 : Metrics.margins.medium)};
`

const CustomThemeContainer = styled(ThemeContainer)`
  padding-left: ${Metrics.components.customThemeSpacing} !important;
  padding-right: ${Metrics.components.customThemeSpacing} !important;
  max-height: ${Metrics.components.adminContent};
  overflow-y: scroll;
`

const SelectAll = styled.div`
  ${Fonts.style.header};
  cursor: pointer;
  float: right;
`

const User = styled.div`
  border-bottom: ${Metrics.borders.headerBorder};
  height: ${Metrics.components.adminListRow};
  width: 100%;
  display: table;
  ${Fonts.style.Text};
  cursor: pointer;
`

const CustomTag = styled(Tag)`
  margin-right: ${Metrics.margins.small};
`

class AdminRequests extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedUsers: [],
      users: [],
      allUsersSelected: false,
      isFetching: false,
      canLoadMore: true
    }

    this.fetchUsers = this.fetchUsers.bind(this)
    this.selectAll = this.selectAll.bind(this)
    this.selectUser = this.selectUser.bind(this)
    this.handleAcceptUsers = this.handleAcceptUsers.bind(this)
    this.handleRejectUsers = this.handleRejectUsers.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
  }

  shouldComponentUpdate (nextProps, nextState) {
    const {
      canLoadMore,
      isFetching,
      users,
      allUsersSelected,
      selectedUsers
    } = this.state
    if (
      canLoadMore !== nextState.canLoadMore ||
      isFetching !== nextState.isFetching ||
      !fromJS(nextState.users).equals(fromJS(users)) ||
      !fromJS(nextState.selectedUsers).equals(fromJS(selectedUsers)) ||
      allUsersSelected !== nextState.allUsersSelected
    ) {
      return true
    }
    return false
  }

  componentWillMount () {
    this.fetchUsers()
  }

  fetchUsers () {
    findUsers({
      query: { state: 'pending' },
      limit: 30,
      skip: this.state.users.length
    })
      .then(response => {
        const list = R.concat(this.state.users, response.data.results)
        this.setState({
          users: list,
          canLoadMore: list.length < response.data.noElems,
          isFetching: false
        })
      })
      .catch(error => {
        console.log(error)
        this.setState({ isFetching: false })
      })
  }

  handleAcceptUsers () {
    acceptUsers(this.state.selectedUsers)
      .then(response => {
        findUsers({ query: { state: 'pending' }, limit: 30 })
          .then(response =>
            this.setState({
              users: response.data.results,
              canLoadMore: response.data.results < response.data.noElems
            })
          )
          .catch(error => console.log(error))
      })
      .catch(error => console.log(error))
  }

  handleRejectUsers () {
    rejectUsers(this.state.selectedUsers)
      .then(response => {
        findUsers({ query: { state: 'pending' }, limit: 5 })
          .then(response =>
            this.setState({
              users: response.data.results,
              canLoadMore: response.data.results < response.data.noElems
            })
          )
          .catch(error => console.log(error))
      })
      .catch(error => console.log(error))
  }

  selectAll () {
    let { allUsersSelected, users, selectedUsers } = this.state
    if (allUsersSelected) {
      selectedUsers = []
    } else {
      selectedUsers = users
    }
    this.setState({ selectedUsers, allUsersSelected: !allUsersSelected })
  }

  selectUser (user) {
    const { selectedUsers } = this.state
    this.setState({
      selectedUsers: addOrRemoveObjectFromList(selectedUsers, user)
    })
  }

  handleScroll (event) {
    const { canLoadMore, isFetching } = this.state
    const element = document.getElementById('admin-requests')
    var hiddenPixels = element.scrollTop
    var difference = element.scrollHeight - element.clientHeight
    var scrollPrecentage = hiddenPixels / difference * 100
    if (scrollPrecentage > 90 && !isFetching && canLoadMore) {
      this.setState({ isFetching: true }, () => this.fetchUsers())
    }
  }

  render () {
    const { t, admin, dropdownLinks, router } = this.props
    const { users, selectedUsers, isFetching } = this.state
    return (
      <PageContainer>
        <AdminNavbar
          fixedSearchBar
          dropdownLinks={dropdownLinks}
          rightSideActions={[
            {
              label: t('Accept'),
              disabled: selectedUsers.length === 0,
              primary: true,
              onClick: this.handleAcceptUsers
            },
            {
              label: t('Reject'),
              disabled: selectedUsers.length === 0,
              secondary: true,
              onClick: this.handleRejectUsers
            }
          ]}
          admin={admin}
        />
        <Loader visible={isFetching} />
        <CustomThemeContainer id='admin-requests' onScroll={this.handleScroll}>
          <CustomCardContainer
            title={
              <div>
                {t('User Requests')}
                <SelectAll onClick={this.selectAll}>
                  {t('Select All')}
                </SelectAll>
              </div>
            }>
            {users &&
              users.length > 0 &&
              users.map((el, index) => {
                return (
                  <User
                    key={`user-${el.email}`}
                    onClick={() => router.push(`/admin/users/${el.id}`)}>
                    <CustomGrid xs={0.5} noPadLeft noPadRight noPadTop>
                      <CustomGrid noPadLeft noPadTop width={40}>
                        <Checkbox
                          id={`checkbox-${el.email}`}
                          checked={isElementInArray(selectedUsers, el)}
                          className='checkbox'
                          onClick={event => {
                            event.stopPropagation()
                            this.selectUser(el)
                          }}
                        />
                      </CustomGrid>
                      <CustomGrid noPadLeft noPadTop width={90}>
                        <Avatar imageSrc={el.picture} size={90} />
                      </CustomGrid>
                      <CustomGrid noPadLeft noPadRight noPadTop>
                        <Title>{`${el.firstName} ${el.lastName}`}</Title>
                        <Preference>{el.email}</Preference>
                      </CustomGrid>
                    </CustomGrid>
                    <CustomGrid xs={0.5} noPadLeft noPadRight noPadTop>
                      <CustomGridContainer
                        xs={1 / 4}
                        noPadLeft
                        noPadRight
                        noPadTop>
                        <Title>{t('Number of keys')}</Title>
                        <Preference>
                          {el.minNoRooms}-{el.maxNoRooms}
                        </Preference>
                      </CustomGridContainer>
                      <CustomGridContainer
                        xs={1 / 4}
                        noPadLeft
                        noPadRight
                        noPadTop>
                        <Title>{t('Estimated Yield')}</Title>
                        <Preference>
                          {el.minYield}-{el.maxYield}
                        </Preference>
                      </CustomGridContainer>
                      <CustomGridContainer
                        xs={1 / 4}
                        noPadLeft
                        noPadRight
                        noPadTop>
                        <Title>{t('Price')}</Title>
                        <Preference>
                          {numberWithCommas(el.minInvestment)}-{numberWithCommas(el.maxInvestment)}
                        </Preference>
                      </CustomGridContainer>
                      <CustomGridContainer
                        xs={1 / 4}
                        noPadLeft
                        noPadRight
                        noPadTop>
                        <Title>{t('Area')}</Title>
                        <Preference>
                          {el.minArea}-{el.maxArea}
                        </Preference>
                      </CustomGridContainer>
                      {el.preferredCategories.length > 0 && (
                        <div style={{ marginTop: Metrics.margins.base }}>
                          {el.preferredCategories.length > 0 &&
                            el.preferredCategories.map((category, index) => {
                              return (
                                <CustomTag
                                  text={category.name}
                                  key={`tag-${el.email}-${index}`}
                                />
                              )
                            })}
                        </div>
                      )}
                    </CustomGrid>
                  </User>
                )
              })}
            {users.length === 0 && (
              <CustomGrid noPadLeft noPadRight noPadTop>
                <Preference>{t('There are no Requests')}</Preference>
              </CustomGrid>
            )}
          </CustomCardContainer>
        </CustomThemeContainer>
      </PageContainer>
    )
  }
}

AdminRequests.propTypes = {
  t: PropTypes.func,
  admin: PropTypes.object,
  dropdownLinks: PropTypes.array,
  router: PropTypes.object
}

export default translate([ 'common', 'admin', 'forms' ], { wait: true })(
  AdminRequests
)



// WEBPACK FOOTER //
// ./src/pages/AdminRequests/index.js